import styled, { type CSSObject } from "styled-components";

interface ContainerProps {
  styles: CSSObject;
}

export const Container = styled.div<ContainerProps>`
  ${({ styles }) => styles}
`;
